"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentApiWebpay = {
    initializePaymentTransaction: function (webPayToken, submissionURL) {
        var form = document.createElement('form');
        form.setAttribute('method', 'POST');
        form.setAttribute('enctype', 'x-www-form-urlencoded');
        form.setAttribute('action', submissionURL);
        form.setAttribute('style', 'display: none');
        var formInput = document.createElement('input');
        formInput.setAttribute('name', 'token_ws');
        formInput.setAttribute('type', 'text');
        formInput.setAttribute('value', webPayToken);
        form.appendChild(formInput);
        document.body.appendChild(form);
        form.submit();
    },
};
